<template>
  <table id="table" border="1" cellpadding="0" cellspacing="0" style="width:100%">
    <caption id="tablePrintText">
      <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
      <div style="font-weight:600">早餐核销统计报表</div>
      <div style="display: flex;justify-content:space-between;">
        <div>
          <span style="font-weight:600"
            v-if="queryShiftValue != ''">班次:{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }}
          </span>
          <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>

        </div>
        <div>
          <span style="font-weight:600">打印人:{{employee.name}}</span>
          <span style="font-weight:600">打印时间:{{currentTime}}</span>
        </div>
      </div>
    </caption>
    <thead>
      <tr v-if="exportShow">
        <th colspan="13">{{hotelInfo.name}}</th>
      </tr>
      <tr v-if="exportShow">
        <th colspan="13">早餐核销统计报表</th>
      </tr>
      <tr v-if="exportShow">
        <th colspan="6">
          <div style="font-weight:600;textAlign:left">
            <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
          </div>
        </th>
        <th style="text-align:right" colspan="7">打印人:{{employee.name}} 打印时间:{{currentTime}}</th>
      </tr>

      <tr>
        <th v-for="(item,index) in nameTitle" :key="index" @click="handleSort(item.key)"
          style="position:sticky;top:0;background-color:#fff;">{{item.name}}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="tr in list" :key="tr.code">
        <td align="center">{{tr.room_num}}</td>
        <td align="center">{{tr.status}}</td>
        <td align="center">{{tr.code}}</td>
        <td align="center">{{tr.name}}</td>
        <td align="center">{{tr.arrive_time}}</td>
        <td align="center">{{tr.leave_time}}</td>
        <td align="center">{{tr.scheme_name }}</td>
        <td align="center">{{tr.quantity}}</td>
        <td align="center">{{tr.package}}</td>
        <td align="center">{{tr.write_off_count}}</td>
        <td align="center">{{tr.emp_name}}</td>
      
        <td align="center">{{tr.write_off_time}}</td>
        <td align="center">{{tr.group_name}}</td>
      </tr>
      <tr v-if="list.length > 0">
        <td align="center">合计</td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>
        <td align="center"></td>

        <td align="center">{{sumsTotal.quantity}}</td>
       
        <td align="center"></td>
        <td align="center">{{sumsTotal.write_off_count}}</td>
        <td align="center"></td>

        <td align="center"></td>
        <td align="center"></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  import DateUtils from '@/utils/DateUtils';
  export default {
    props: {
      tabelList: {
        type: Array,
        default: []
      },
      sumsTotal: {
        type: Object,
      },
      listQuery: {
        type: Object,
      },
      exportShow: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      list() {
        return this.tabelList
      }
    },
    data() {
      return {
        employee: JSON.parse(localStorage.getItem('user')),
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: JSON.parse(localStorage.getItem('hotel')),
        nameTitle: [{
            name: '房号',
            key: 'room_num'
          },
          {
            name: '状态',
            key: 'status'
          },
          {
            name: '账号',
            key: 'code'
          },
          {
            name: '姓名',
            key: 'name'
          },
          {
            name: '到店',
            key: 'arrive_time'
          },
          {
            name: '离店',
            key: 'leave_time'
          },
          {
            name: '房价码',
            key: 'scheme_name'
          },
          {
            name: '早餐数量',
            key: 'quantity'
          },
          {
            name: '包价',
            key: 'package'
          },
          {
            name: '核销数量',
            key: 'write_off_count'
          },
          {
            name: '核销工号',
            key: 'emp_name'
          },
          {
            name: '核销时间',
            key: 'write_off_time'
          },
          {
            name: '团名',
            key: 'group_name'
          },
        ],
        sort: false,
        queryShiftValue: '',
      }
    },
    methods: {
      //排序
      handleSort(val) {
        if (this.sort) {
          if (typeof (this.list[0][val]) == 'number') {
            this.list.sort(function (a, b) {
              return a[val] - b[val]
            })
          } else {
            this.list.sort(
              function compareFunction(param1, param2) {
                return param1[val].localeCompare(param2[val], 'zh-Hans-CN', {
                  sensitivity: 'accent'
                });
              }
            )
          }
          this.sort = false
        } else {
          if (typeof (this.list[0][val]) == 'number') {
            this.list.sort(function (a, b) {
              return b[val] - a[val]
            })
          } else {
            this.list.sort(
              function compareFunction(param1, param2) {
                return param2[val].localeCompare(param1[val], 'zh-Hans-CN', {
                  sensitivity: 'accent'
                });
              }
            )
          }
          this.sort = true
        }
      },

    },
    mounted() {
      this.$bus.$on('renderQueryShiftValue', val => {
        this.queryShiftValue = val;
      });
    }

  }
</script>